import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAddNewHepMutation } from "./hepApiSlice"
import { useGetUsersQuery } from '../users/usersApiSlice'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave, faFilePen } from "@fortawesome/free-solid-svg-icons"
import { toast } from 'react-toastify'
import useAuth from "../../hooks/useAuth"


const NewHepForm = ({ users }) => {

    const { userId, isManager, isAdmin } = useAuth()

    // get user data for manager: start
    const { user } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            user: data?.entities[userId]
        }),
    })
    let staffMembers=null
    if (isManager) {
        // get staff members, used for managers only
        staffMembers=user.staff

        // add manager id for current users
        staffMembers= [...staffMembers, userId]
    }
    // get user data for manager: end
    
    
    const [addNewHep, {
        data,
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddNewHepMutation()

    const navigate = useNavigate()

    const [title, setTitle] = useState('')
    const [text, setText] = useState('')
    const [userID, setUserID] = useState(userId)

    useEffect(() => {
        if (isSuccess) {
            setTitle('')
            setText('')
            setUserID('')
            toast.success("HEP was Created");
            navigate(`/dash/hep/${data.newHepId}`)
        }

        if (isError) {
            toast.error(error?.data?.message);
        }
        
    }, [isSuccess, isError, error]) // eslint-disable-line react-hooks/exhaustive-deps

    const onTitleChanged = e => setTitle(e.target.value)
    const onTextChanged = e => setText(e.target.value)
    const onUserIDChanged = e => setUserID(e.target.value)

    const canSave = [title, text, userId].every(Boolean) && !isLoading

    const onSaveHepClicked = async (e) => {
        e.preventDefault()
        if (canSave) {
            await addNewHep({ user: userID, title, text })
        }
    }

    let filteredIds=null
    if (isAdmin) {
        // show all HEPs
        filteredIds = [...users]
    } else if (isManager){
        //only show staff members
        filteredIds = users.filter(user_ID => staffMembers.includes(user_ID.id))
    } else {
        // only show HEPs for current user
        filteredIds = users.filter(user_ID => user.id === user_ID.id)
    }


    const options = filteredIds.map(user => {
        return (
            <option key={user.id} value={user.id}>
                {user.lastname}, {user.firstname}
            </option >
        )
    })

    const content = (
        <section id="main_content">
            <header>
                <h1 className="text-steel mt-5"><FontAwesomeIcon icon={faFilePen} style={{fontSize:"30px", marginRight:"5px"}} />New Home Program</h1>
            </header>
            <main>
                <form onSubmit={e => e.preventDefault()}>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label" htmlFor="hep-title">
                                Title:</label>
                            <input
                                className="form-control"
                                id="hep-title"
                                name="title"
                                type="text"
                                autoComplete="off"
                                value={title}
                                onChange={onTitleChanged}
                            />
                            <label className="form-label" htmlFor="hep-username">Therapist:</label>
                            <select
                                id="hep-username"
                                name="username"
                                className="form-select"
                                value={userID}
                                onChange={onUserIDChanged}
                            >
                                {options}
                            </select>
                        </div>

                        <div className="col-md-6">
                            <label className="form-label" htmlFor="hep-text">
                                Instructions:</label>
                            <textarea
                                className="form-control"
                                id="hep-text"
                                rows="8"
                                name="text"
                                value={text}
                                onChange={onTextChanged}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 text-end">
                            <span
                                role="button"
                                title="Save"
                                className="text-success p-2 icon"
                                onClick={onSaveHepClicked}
                                disabled={!canSave}
                            >
                                Save
                                <FontAwesomeIcon icon={faSave}  className="fa-icon"/>
                            </span>
                        </div>
                    </div>
                    
                </form>
            </main>
        </section>    )

    return content
}

export default NewHepForm